import { LitElement, html, css, render } from 'lit';
import { search } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { arrowBack } from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInLocationSearch extends LitElement {
    static properties = {
        name: { type: String },
        loading: { type: Boolean, state: true },
        restUrl: { type: String },
        nonce: { type: String },
        locations: { type: Array, state: true },
        location: { type: Object, state: true },
        noLocation: { type: Boolean, state: true },
        freshlyCleared: { type: Boolean, state: true },
        locationUrl: { type: String },
        locationName: { type: String },
        value: { type: String },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        if (this.value) {
            await this._fetchLocation(this.value);
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('location')) {
            this.eventManager.emit(`location-selected-${this.name}`, this.location);
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        let main;
        if (this.location) {
            main = html `\n                <div class="selected-location">\n                    ${this.location.location_data.photo1 ? html `<img src="${this.location.location_data.photo1.publicUrl}" alt="${this.location.location_data.name} image" />` : html `<div class="placeholder-image" aria-label="Dim delwedd ar gael"></div>`}\n                    <h4>${this.location.location_data.name}</h4>\n                    <button class="button" @click=${(e) => { this._selectLocation(null, e); this.freshlyCleared = true; }}>Newid lleoliad</button>\n                </div>\n            `;
        }
        else if (this.noLocation || this.locationUrl) {
            main = html `\n                <div class="no-location">\n                    <label for="locationUrl">Ychwanegwch ddolen i\u2019r dudalen gwybodaeth am fynediad ar gyfer eich digwyddiad teithio</label>\n                    <input type="url" id="locationUrl" name="locationUrl" placeholder="Ychwanegwch ddolen i\u2019r dudalen gwybodaeth am fynediad ar gyfer eich digwyddiad teithio" value="${this.locationUrl ?? ''}" aria-required="true" @blur=${this._slotURLChangeOnline}/>\n\n                    <label for="locationName">Ychwanegwch enw ar gyfer eich lleoliad teithio</label>\n                    <input type="text" id="locationName" name="locationName" placeholder="Ychwanegwch enw ar gyfer eich lleoliad teithio" value="${this.locationName ?? ''}" @input=${this._handleLocationNameChange}/>\n                    <button class="back" @click=${(e) => { e.preventDefault(); this.noLocation = false; this.locationUrl = '', this.locationName = '', this.freshlyCleared = true; }}><span aria-hidden="true">${arrowBack}</span>Chwilio eto</button>\n                </div>\n            `;
        }
        else {
            main = html `\n                <div class="allin-location-search-form ${this.loading ? "loading" : ""}" ?aria-busy=${this.loading} >\n                    <div class="searchboxes">\n                        <div class="searchbox">\n                            <label for="allin-listings-search">Chwilio am eich lleoliad teithio</label>\n                            ${search}\n                            <input type="text" id="allin-listings-search" name="search" value="${this.search}" @keydown=${this._handleKeydown}/>\n                        </div>\n                        <button class="button" ?disabled=${this.loading} @click=${this._handleSubmit}>Chwilio</button>\n                    </div>\n                    <div class="message" aria-live="polite"></div>\n                </div>\n            `;
        }
        let locationsList;
        if (this.locations && this.locations.length > 0) {
            locationsList = html `\n                <ul class="locations-list">\n                ${this.locations.map((loc) => html `\n                        <li class="location">\n                            ${loc.photo1 ? html `<img src="${loc.photo1.publicUrl}" alt="${loc.name} image" />` : html `<div class="placeholder-image" aria-label="Dim delwedd ar gael"></div>`}\n                            <h4>${loc.name}</h4>\n                            <button type="button" @click=${(e) => this._selectLocation(loc, e)}>Dewis <span class="screen-reader-text">${loc.name}</span></button>\n                        </li>\n                    `)}\n                </ul>\n                <div class="button_group button-group">\n                    <button class="button" @click=${(e) => { e.preventDefault(); this.locations = []; this.freshlyCleared = true; }}>Clirio\u2019r canlyniadau chwilio</button>\n                    <button class="button" @click=${this._handleNoLocationFound}>Methu dod o hyd i\u2019r lleoliad</button>\n                </div>\n             `;
        }
        else if (this.locations && this.locations.length === 0 && !this.loading && !this.noLocation && !this.locationUrl && !this.location && !this.freshlyCleared && !this.locationName) {
            locationsList = html `\n                <p>Heb ddod o hyd i leoliad. Defnyddiwch derm arall i\u2019w chwilio.</p>\n                 <div class="button_group button-group">\n                    <button class="button" @click=${(e) => { e.preventDefault(); this.locations = []; this.freshlyCleared = true; }}>Clirio\u2019r canlyniadau chwilio</button>\n                    <button class="button" @click=${this._handleNoLocationFound}>Methu dod o hyd i\u2019r lleoliad</button>\n                </div>\n            `;
        }
        return html `\n            <input type="hidden" name="locationId" .value=${this.location ? this.location.id : ''} />\n            <input type="hidden" name="locationName" .value=${this.locationName ?? ''} />\n            <div class="bg">\n                ${main}\n                ${locationsList}\n            </div>\n        `;
    }
    async _handleSubmit(e) {
        e.preventDefault();
        this.loading = true;
        this.freshlyCleared = false;
        const search = this.renderRoot.querySelector('#allin-listings-search').value;
        const messageEl = this.renderRoot.querySelector('.message');
        if (messageEl) {
            messageEl.textContent = '';
        }
        if (!search || search.trim() === '' || search.trim().length < 3) {
            this.loading = false;
            if (messageEl) {
                messageEl.textContent = `Rhowch o leiaf 3 nod i chwilio.`;
            }
            return;
        }
        const params = new URLSearchParams();
        if (search)
            params.append('search', search);
        if (this._pageNumber)
            params.append('pageNumber', this._pageNumber);
        try {
            const response = await fetch(`${this.restUrl}?action=get_locations&${params.toString()}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this.locations = data.data;
            }
        }
        catch (error) {
            console.error('Error fetching locations:', error);
        }
        finally {
            this.loading = false;
        }
    }
    _selectLocation(location, e) {
        e.preventDefault();
        this.freshlyCleared = false;
        if (location) {
            this.location = { id: location.id, location_data: location };
        }
        else {
            this.location = null;
        }
        this.locations = [];
    }
    _handleKeydown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this._handleSubmit(e);
        }
    }
    _slotURLChangeOnline(e) {
        const value = e.target.value?.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            e.target.value = `https://${value}`;
        }
    }
    _fetchLocation = async (locationId) => {
        this.loading = true;
        try {
            const response = await fetch(`${this.restUrl}?action=get_location&location_id=${locationId}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this.location = { id: data.id, location_data: data };
            }
        }
        catch (error) {
            console.error('Error fetching location:', error);
        }
        finally {
            this.loading = false;
        }
    };
    _handleNoLocationFound(e) {
        e.preventDefault();
        this.noLocation = true;
        this.freshlyCleared = false;
        this.locations = [];
        this.eventManager.emit(`no-location-found-${this.name}`);
    }
    // New handler for LocationName field in location Search for Touring event
    _handleLocationNameChange(e) {
        this.locationName = e.target.value;
    }
}
